import {
  GRAPHQL_API_URL as GRAPHQL_API_URL_,
  GRAPHQL_WS_BASE_URL,
} from "@opensea/utils"

export const GRAPHQL_API_URL = GRAPHQL_API_URL_.toString()
export const GRAPHQL_WS_URL = `${GRAPHQL_WS_BASE_URL}/subscriptions`
const GRAPHQL_API_KEY = process.env.GRAPHQL_API_KEY
const GRAPHQL_CF_ACCESS_ID = process.env.GRAPHQL_CF_ACCESS_ID
const GRAPHQL_CF_ACCESS_SECRET = process.env.GRAPHQL_CF_ACCESS_SECRET
const APP_ID_HEADER = "x-app-id"

export const GRAPHQL_HEADERS: HeadersInit = {
  [APP_ID_HEADER]: "os2-web",
  ...(typeof window === "undefined"
    ? { "user-agent": "OpenSea/Next/SSR" }
    : {}),
  ...(GRAPHQL_API_KEY ? { "x-api-key": GRAPHQL_API_KEY } : {}),
  ...(GRAPHQL_CF_ACCESS_ID
    ? { "CF-Access-Client-Id": GRAPHQL_CF_ACCESS_ID }
    : {}),
  ...(GRAPHQL_CF_ACCESS_SECRET
    ? { "CF-Access-Client-Secret": GRAPHQL_CF_ACCESS_SECRET }
    : {}),
}
